import { useDataLayerWithEventStack } from '@wkda/funnel-components';
import { CarleadDataLayer } from '@wkda/funnel-data-layers';
import { useCarleadConfiguration } from './useCarleadCreationConfiguration';
export function useCarleadDataLayer() {
  const {
    fullLocale: locale
  } = useCarleadConfiguration();
  const dataLayer = useDataLayerWithEventStack(CarleadDataLayer, locale);
  return dataLayer;
}